import type { SVGAttributes } from "react";

/* eslint-disable max-len */
export const TargetIcon = (props: SVGAttributes<SVGSVGElement> & { size?: CSSStyleDeclaration["width"] }) => {
    return (
        <svg
            width={props.size || props.width || 56}
            height={props.size || props.height || 56}
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M47.0322 11.9C48.1366 11.9003 49.0322 12.7956 49.0322 13.9V41.6012C49.0322 42.7056 48.1366 43.601 47.0322 43.6012H9C7.89543 43.6012 7 42.7058 7 41.6012V13.9C7 12.7955 7.89543 11.9 9 11.9H47.0322ZM11.1016 14.0992C10.4014 14.0994 9.83398 14.6676 9.83398 15.3678C9.83422 16.0678 10.4015 16.6352 11.1016 16.6354C11.8017 16.6354 12.3699 16.0679 12.3701 15.3678C12.3701 14.6675 11.8019 14.0992 11.1016 14.0992ZM15.4561 14.0992C14.7557 14.0992 14.1875 14.6675 14.1875 15.3678C14.1877 16.0679 14.7559 16.6354 15.4561 16.6354C16.1561 16.6352 16.7234 16.0678 16.7236 15.3678C16.7236 14.6676 16.1562 14.0994 15.4561 14.0992ZM19.8096 14.0992C19.1093 14.0993 18.542 14.6675 18.542 15.3678C18.5422 16.0679 19.1094 16.6353 19.8096 16.6354C20.5098 16.6354 21.0779 16.0679 21.0781 15.3678C21.0781 14.6675 20.5099 14.0992 19.8096 14.0992Z"
                fill="url(#paint0_linear_405_4144)"
            />
            <path
                opacity="0.8"
                d="M47.0322 11.9C48.1366 11.9003 49.0322 12.7956 49.0322 13.9V18.8346H7V13.9C7 12.7955 7.89543 11.9 9 11.9H47.0322ZM11.1016 14.0992C10.4014 14.0994 9.83398 14.6676 9.83398 15.3678C9.83422 16.0678 10.4015 16.6352 11.1016 16.6354C11.8017 16.6354 12.3699 16.0679 12.3701 15.3678C12.3701 14.6675 11.8019 14.0992 11.1016 14.0992ZM15.4561 14.0992C14.7557 14.0992 14.1875 14.6675 14.1875 15.3678C14.1877 16.0679 14.7559 16.6354 15.4561 16.6354C16.1561 16.6352 16.7234 16.0678 16.7236 15.3678C16.7236 14.6676 16.1562 14.0994 15.4561 14.0992ZM19.8096 14.0992C19.1093 14.0993 18.542 14.6675 18.542 15.3678C18.5422 16.0679 19.1094 16.6353 19.8096 16.6354C20.5098 16.6354 21.0779 16.0679 21.0781 15.3678C21.0781 14.6675 20.5099 14.0992 19.8096 14.0992Z"
                fill="url(#paint1_linear_405_4144)"
            />
            <path
                d="M33.7322 24.6004C33.144 24.4517 32.6104 24.9853 32.759 25.5735L35.5015 36.4287C35.6539 37.0316 36.4052 37.2387 36.8449 36.799L38.9255 34.7184C39.2384 34.4055 39.7457 34.4055 40.0586 34.7184L43.6742 38.334C43.9871 38.6469 44.4944 38.6469 44.8074 38.334L46.4923 36.6491C46.8052 36.3362 46.8052 35.8288 46.4923 35.5159L42.8767 31.9003C42.5638 31.5874 42.5638 31.0801 42.8767 30.7672L44.9573 28.6866C45.397 28.2469 45.19 27.4956 44.587 27.3432L33.7322 24.6004Z"
                fill="url(#paint2_linear_405_4144)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.4264 25.5038C16.6933 25.5038 14.4776 27.7194 14.4776 30.4525C14.4776 33.1856 16.6933 35.4012 19.4264 35.4012C22.1595 35.4012 24.3751 33.1856 24.3751 30.4525C24.3751 27.7194 22.1595 25.5038 19.4264 25.5038ZM12.7446 30.4525C12.7446 26.7623 15.7361 23.7708 19.4264 23.7708C23.1166 23.7708 26.1081 26.7623 26.1081 30.4525C26.1081 34.1427 23.1166 37.1342 19.4264 37.1342C15.7361 37.1342 12.7446 34.1427 12.7446 30.4525Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.4266 20.7812C19.9051 20.7812 20.2931 21.1692 20.2931 21.6478V39.2571C20.2931 39.7356 19.9051 40.1236 19.4266 40.1236C18.948 40.1236 18.5601 39.7356 18.5601 39.2571V21.6478C18.5601 21.1692 18.948 20.7812 19.4266 20.7812Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.75537 30.4525C9.75537 29.9739 10.1433 29.586 10.6219 29.586L28.2312 29.586C28.7098 29.586 29.0977 29.9739 29.0977 30.4525C29.0977 30.931 28.7098 31.319 28.2312 31.319L10.6219 31.319C10.1433 31.319 9.75537 30.931 9.75537 30.4525Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_405_4144"
                    x1="7"
                    y1="13.272"
                    x2="43.5298"
                    y2="39.889"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop
                        offset="0.0653577"
                        stopColor="#195AFE"
                    />
                    <stop
                        offset="1"
                        stopColor="#BCCFFF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_405_4144"
                    x1="49.0322"
                    y1="18.8346"
                    x2="8.00494"
                    y2="16.3938"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="1"
                        stopColor="white"
                        stopOpacity="0.39"
                    />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_405_4144"
                    x1="37.5032"
                    y1="29.3448"
                    x2="45.6498"
                    y2="37.4915"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="1"
                        stopColor="white"
                        stopOpacity="0.3"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
};
